<template>
  <div v-loading.body="loading">
    <el-row class="shop-data">
      <el-col :span="24">
        <div style="font-size: 14px;" v-if="this.dataDetails[0]">
          {{ generateCustomizeString('dataUpdatedAt') }}：{{ this.nowTime }}
        </div>
        <p style="font-size: 12px; color: red;">
          {{ generateCustomizeString('statisticsNotice') }}
        </p>
      </el-col>
      <el-col
        :span="24"
        style="margin-top: 10px; border: 1px solid #e6e6e6; border-radius: 5px;"
      >
        <el-row>
          <el-col :span="24">
            <div class="statistics-title">
              {{ generateCustomizeString('keyIndicator') }}
            </div>
          </el-col>
          <el-col :span="6" class="statistics">
            <div>{{ generateCustomizeString('totalToday') }}</div>
            <div style="line-height: 40px; font-size: 24px;">
              NZD ${{
                parseFloat(this.salesData.today_sales_amount / 100).toFixed(2)
              }}
            </div>
          </el-col>
          <el-col :span="6" class="statistics">
            <div>{{ generateCustomizeString('totalYesterday') }}</div>
            <div style="line-height: 40px; font-size: 24px;">
              NZD ${{
                parseFloat(this.salesData.yesterday_sales_amount / 100).toFixed(
                  2
                )
              }}
            </div>
          </el-col>
          <el-col :span="6" class="statistics">
            <div>{{ generateCustomizeString('totalThisMonth') }}</div>
            <div style="line-height: 40px; font-size: 24px;">
              NZD ${{
                parseFloat(this.salesData.month_sales_amout / 100).toFixed(2)
              }}
            </div>
          </el-col>
          <el-col :span="6" style="padding: 40px 0 30px 30px;">
            <div>{{ generateCustomizeString('totalPrevMonth') }}</div>
            <div style="line-height: 40px; font-size: 24px;">
              NZD ${{
                parseFloat(
                  this.salesData.last_month_sales_amount / 100
                ).toFixed(2)
              }}
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24" style="margin-top: 30px;">
        <el-form :inline="true" ref="searchForm" :model="searchForm">
          <el-form-item :label="generateCustomizeString('time')">
            <el-date-picker
              v-model="searchForm.dataPicker"
              size="mini"
              style="vertical-align: middle;"
              type="daterange"
              align="right"
              unlink-panels
              :range-separator="generateCustomizeString('to')"
              :start-placeholder="generateCustomizeString('startDate')"
              :end-placeholder="generateCustomizeString('endDate')"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="mini"
              @click="selectDate"
              v-if="this.searchForm.dataPicker"
              >{{ generateCustomizeString('confirm') }}</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="selectDate"
              v-else
              disabled
              >{{ generateCustomizeString('confirm') }}</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24" style="margin-top: 10px; padding-top: 10px;">
        <div id="app" class="shop-chart">
          <div style="font-size: 16px; font-weight: bold;">
            {{ generateCustomizeString('trend') }}
          </div>
          <ve-line :data="chartData" :settings="chartSettings"></ve-line>
        </div>
      </el-col>
      <el-col style="padding: 50px 0 10px 30px;">
        <div style="font-size: 16px; font-weight: bold;">
          {{ generateCustomizeString('detailData') }}
          <el-radio-group
            v-model="dateRange"
            size="small"
            style="margin-left: 30px;"
            @change="selectDataUnit()"
          >
            <el-radio-button
              :label="generateCustomizeString('day')"
            ></el-radio-button>
            <el-radio-button
              :label="generateCustomizeString('week')"
            ></el-radio-button>
            <el-radio-button
              :label="generateCustomizeString('month')"
            ></el-radio-button>
          </el-radio-group>
          <el-button
            @click="handleExport"
            size="small"
            style="margin-left:10px"
            type="primary"
            :disabled="is_export_btn_disable"
          >
            {{ generateCustomizeString('exportCurrentData') }}</el-button
          >
          <el-button
            @click="handleExportAll"
            size="small"
            style="margin-left:10px"
            type="primary"
            :disabled="is_export_all_btn_disable"
          >
            {{ generateCustomizeString('exportAllData') }}</el-button
          >
        </div>
      </el-col>
      <el-col style="padding-bottom: 100px;">
        <el-table :data="dataDetails" tooltip-effect="dark" style="width: 100%">
          <el-table-column
            prop="stat_date"
            :label="generateCustomizeString('time')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.stat_date.substr(0, 10) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="wechat_amount"
            :label="generateCustomizeString('wechatPay')"
          >
            <template slot-scope="scope">
              <span
                >NZD ${{
                  parseFloat(scope.row.wechat_amount / 100).toFixed(2)
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="alipay_amount"
            :label="generateCustomizeString('alipay')"
          >
            <template slot-scope="scope">
              <span
                >NZD ${{
                  parseFloat(scope.row.alipay_amount / 100).toFixed(2)
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="paypal_amount" label="PayPal">
            <template slot-scope="scope">
              <span
                >NZD ${{
                  parseFloat(scope.row.paypal_amount / 100).toFixed(2)
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="polipay_amount"
            :label="generateCustomizeString('PoliPay')"
          >
            <template slot-scope="scope">
              <span
                >NZD ${{
                  parseFloat(scope.row.polipay_amount / 100).toFixed(2)
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="union_amount"
            :label="generateCustomizeString('UnionPay')"
          >
            <template slot-scope="scope">
              <span
                >NZD ${{
                  parseFloat(scope.row.union_amount / 100).toFixed(2)
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="balance_pay_amount"
            :label="generateCustomizeString('creditPay')"
          >
            <template slot-scope="scope">
              <span
                >NZD ${{
                  parseFloat(scope.row.balance_pay_amount / 100).toFixed(2)
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="offline_pay_amount"
            :label="generateCustomizeString('onfflinePay')"
          >
            <template slot-scope="scope">
              <span
                >NZD ${{
                  parseFloat(scope.row.offline_pay_amount / 100).toFixed(2)
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="refund_amount"
            :label="generateCustomizeString('refundAmount')"
          >
            <template slot-scope="scope">
              <span
                >NZD ${{
                  parseFloat(scope.row.refund_amount / 100).toFixed(2)
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="all_order_count"
            :label="generateCustomizeString('totalSales')"
          >
            <template slot-scope="scope">
              <span
                >NZD ${{
                  parseFloat(scope.row.sales_amount / 100).toFixed(2)
                }}</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-col style="margin-top: 10px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="currentTotal"
          ></el-pagination>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
import VeLine from 'v-charts/lib/line'
import moment from 'moment'
import { generateCustomizeString } from '@/utils/i18n'
import downloadSCV from '@/utils/exportCSV'

const originOrderSearchFrom = {
  dataPicker: []
}

export default {
  name: 'SalesStatistics',
  components: {
    VeLine
  },
  data() {
    return {
      is_export_btn_disable: true,
      is_export_all_btn_disable: true,
      nowTime: '',
      currentPage: 1,
      currentTotal: 0,
      pageSize: 10,
      total_rows: null,
      time: this.generateCustomizeString('sevenDays'),
      searchForm: Object.assign({}, originOrderSearchFrom),
      loading: false,
      dataDetails: [],
      salesData: {
        today_sales_amount: 0,
        yesterday_sales_amount: 0,
        month_sales_amout: 0,
        last_month_sales_amount: 0
      },
      filters: {},
      pickerOptions: {
        shortcuts: [
          {
            text: this.generateCustomizeString('last7Days'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.generateCustomizeString('last14Days'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.generateCustomizeString('last30Days'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      chartSettings: {
        stack: { 日期: ['Sales'] },
        area: true
      },
      chartData: {
        columns: ['Date', 'Sales'],
        rows: []
      },
      dateRange: '日',
      dataUnit: 4
    }
  },
  methods: {
    generateCustomizeString,
    selectDate() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          if (this.searchForm.dataPicker.length === 2) {
            const dates = this.searchForm.dataPicker.map(date =>
              moment(date).format('YYYY-MM-DD HH:mm:ss')
            )
            params.start_date = dates[0]
            params.end_date = dates[1]
            delete params.dataPicker
          }
          console.log(params)
          this.filters = params
          this.fetchDataDetails(1)
        } else {
          console.log('data error')
        }
      })
    },
    handleExport() {
      if (this.currentTotal <= 0) {
        return
      }
      downloadSCV(this.getCSV_title, this.getCSV_content, `commodity_sales`)
    },
    handleExportAll() {
      if (this.currentTotal <= 0) {
        return
      }
      this.is_export_all_btn_disable = true
      request({
        url: '/stat/history',
        method: 'get',
        params: {
          page: 1,
          page_size: this.total_rows,
          unit: this.dataUnit,
          ...this.filters
        }
      }).then(({ data }) => {
        const _data = data.map(({
          stat_date,
          wechat_amount,
          alipay_amount,
          paypal_amount,
          polipay_amount,
          union_amount,
          balance_pay_amount,
          offline_pay_amount,
          refund_amount,
          sales_amount
        }) => {
          return {
            stat_date: stat_date.substr(0, 10),
            wechat_amount: (wechat_amount / 100).toFixed(0, 2).toString(),
            alipay_amount: (alipay_amount / 100).toFixed(0, 2),
            paypal_amount: (paypal_amount / 100).toFixed(0, 2),
            polipay_amount: (polipay_amount / 100).toFixed(0, 2),
            union_amount: (union_amount / 100).toFixed(2),
            balance_pay_amount: (balance_pay_amount / 100).toFixed(2),
            offline_pay_amount: (offline_pay_amount / 100).toFixed(2),
            refund_amount: (refund_amount / 100).toFixed(2),
            sales_amount: (sales_amount / 100).toFixed(2)
          }
        })
        downloadSCV(this.getCSV_title, _data, `all_commodity_sales`)
        this.is_export_all_btn_disable = false
      })
    },
    selectDataUnit() {
      if (this.dateRange === '日') {
        this.dataUnit = 4
      } else if (this.dateRange === '周') {
        this.dataUnit = 5
      } else {
        this.dataUnit = 6
      }
      this.fetchDataDetails(1)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchDataDetails(1)
    },
    handleCurrentChange(val) {
      this.fetchDataDetails(val)
    },
    fetchData() {
      request({
        url: '/stat/board/sales/amount',
        method: 'get'
      })
        .then(response => {
          const data = response.data
          this.salesData = data
        })
        .catch(error => {
          console.warn(error)
        })
    },
    fetchDataDetails(page) {
      this.is_export_btn_disable = true
      request({
        url: '/stat/history',
        method: 'get',
        params: {
          page: page,
          page_size: this.pageSize,
          unit: this.dataUnit,
          ...this.filters
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          this.dataDetails = data
          this.chartData.rows = []
          for (var i = 0; i < this.dataDetails.length; i++) {
            var obj = {}
            obj['Date'] = this.dataDetails[i].stat_date.substr(0, 10)
            obj['Sales'] = this.dataDetails[i].sales_volume
            this.chartData.rows.push(obj)
          }
          this.chartData.rows.reverse()
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
          this.total_rows = meta.total
          this.is_export_btn_disable = false
          this.is_export_all_btn_disable = false
        })
        .catch(error => {
          console.warn(error)
        })
    }
  },
  computed: {
    getCSV_title() {
      return [
        this.generateCustomizeString('time'),
        this.generateCustomizeString('wechatPay') + '(nzd$)',
        this.generateCustomizeString('alipay') + '(nzd$)',
        'PayPal',
        this.generateCustomizeString('PoliPay') + '(nzd$)',
        this.generateCustomizeString('UnionPay') + '(nzd$)',
        this.generateCustomizeString('creditPay') + '(nzd$)',
        this.generateCustomizeString('onfflinePay') + '(nzd$)',
        this.generateCustomizeString('refundAmount') + '(nzd$)',
        this.generateCustomizeString('totalSales') + '(nzd$)'
      ]
    },
    getCSV_content() {
      return this.dataDetails.map(
        ({
          stat_date,
          wechat_amount,
          alipay_amount,
          paypal_amount,
          polipay_amount,
          union_amount,
          balance_pay_amount,
          offline_pay_amount,
          refund_amount,
          sales_amount
        }) => {
          return {
            stat_date: stat_date.substr(0, 10),
            wechat_amount: (wechat_amount / 100).toFixed(0, 2).toString(),
            alipay_amount: (alipay_amount / 100).toFixed(0, 2),
            paypal_amount: (paypal_amount / 100).toFixed(0, 2),
            polipay_amount: (polipay_amount / 100).toFixed(0, 2),
            union_amount: (union_amount / 100).toFixed(2),
            balance_pay_amount: (balance_pay_amount / 100).toFixed(2),
            offline_pay_amount: (offline_pay_amount / 100).toFixed(2),
            refund_amount: (refund_amount / 100).toFixed(2),
            sales_amount: (sales_amount / 100).toFixed(2)
          }
        }
      )
    }
  },
  created: function() {
    var date = new Date()
    this.nowTime =
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1) +
      '-' +
      date.getDate() +
      ' ' +
      '00:00:00'
    this.fetchData()
    this.fetchDataDetails(1)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.shop-data {
  padding: 30px;
}
.statistics-title {
  padding-left: 10px;
  background-color: #f1f1f1;
  font-size: 16px;
  font-weight: bold;
  line-height: 40px;
  border-bottom: 1px solid #e6e6e6;
}
.statistics {
  border-right: 1px solid #e6e6e6;
  padding: 40px 0 30px 30px;
}
.shop-chart {
  padding: 20px 30px;
  height: 460px;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-color: #fdfdfd;
}
</style>
<style type="text/css">
.el-input__icon {
  line-height: 20px;
}
</style>
